// AuthSetup.js
import { useEffect } from 'react';
import { useAuth } from './auth';
import { injectAuthHelper } from '../common/apiClient';

export default function AuthSetup() {
  const { setUserFromToken, logout } = useAuth();

  useEffect(() => {
    injectAuthHelper({
      setUserFromToken,
      redirectToLogin: logout,
    });
  }, [setUserFromToken, logout]);

  return null;
}
